import { eachDayOfInterval, format, subDays } from 'date-fns'
import { useMemo } from 'react'
import { Bar, BarChart, CartesianGrid } from 'recharts'
import { type ChartConfig, ChartContainer } from '@/components/sv/chart'

const EMPTY_CHART_CONFIG: ChartConfig = {
  value: {
    label: 'Spending',
    color: 'var(--accent)',
  },
}

export const EmptyUsageChart = () => {
  const chartData = useMemo(() => {
    const now = new Date()
    return eachDayOfInterval({ start: subDays(now, 31), end: now }).map(
      (date) => ({
        day: format(date, 'MMM dd'),
        value: Math.floor(Math.random() * 10) + 1,
      })
    )
  }, [])

  return (
    <div className="py-6 px-6">
      <p className="text-sm text-muted-foreground text-center mb-4">
        Usage data will appear here once your services start generating usage.
        There may be a 6-8 hour delay before data is available.
      </p>
      <ChartContainer
        config={EMPTY_CHART_CONFIG}
        className="min-h-[250px] max-h-[350px] w-full opacity-30 [&_.recharts-responsive-container]:max-h-[350px]"
      >
        <BarChart accessibilityLayer data={chartData}>
          <CartesianGrid vertical={false} />
          <Bar dataKey="value" fill="var(--accent)" />
        </BarChart>
      </ChartContainer>
    </div>
  )
}
